import { Controller } from "@hotwired/stimulus"
import "whatwg-fetch"

export default class extends Controller {
  static targets = ["league", "link", "loader", "summerTab", "fallTab"]

  markers = []

  connect() {
    const coords = {
      lat: this.data.get("lat") ? parseFloat(this.data.get("lat")) : 39.5,
      lng: this.data.get("lng") ? parseFloat(this.data.get("lng")) : -98.35
    }

    let map

    const initMap = async () => {
      const { Map } = await google.maps.importLibrary("maps")

      this.map = new Map(document.getElementById("leagues-map"), {
        zoom: 10,
        center: coords,
        mapTypeId: "roadmap",
        scrollwheel: false,
        mapTypeControl: false,
        streetViewControl: false,
        fullscreenControl: false,
        gestureHandling: "greedy"
      })

      this.renderLeagues()
    }

    initMap()
  }

  updateLocationFromCurrentLocation(event) {
    event.preventDefault()
    Turbo.cache.clear()()
    if (this.hasLinkTarget) {
      this.linkTarget.style.display = "none"
    }
    if (this.hasLoaderTarget) {
      this.loaderTarget.style.display = ""
    }
    navigator.geolocation.getCurrentPosition(
      (position) => {
        console.log("current position", position)
        fetch("/current_location", {
          method: "post",
          headers: {
            "Content-Type": "application/json",
            "X-CSRF-Token": document.querySelector("meta[name=csrf-token]").content
          },
          body: JSON.stringify({ lat: position.coords.latitude, lng: position.coords.longitude })
        }).then((response) => {
          console.log("fetch current location response", response)
          if (response.redirected) {
            window.location = response.url
          }
        })
      },
      (err) => {
        console.log("Could not get location", err)
        if (this.hasLinkTarget) {
          this.linkTarget.style.display = ""
        }
        if (this.hasLoaderTarget) {
          this.loaderTarget.style.display = "none"
        }
        alert("Could not determine current location")
      },
      {
        enableHighAccuracy: false,
        timeout: 10000,
        maximumAge: 1000 * 60 * 60
      }
    )
  }

  renderLeagues = () => {
    if (this.hasLeagueTarget) {
      for (let m of this.markers) {
        m.setMap(null)
      }

      this.markers = []

      for (let leagueTarget of this.leagueTargets) {
        const content = document.getElementById(`league-${leagueTarget.dataset.id}-map-popup`).innerHTML

        const infoWindow = new google.maps.InfoWindow({ content: `<div class="league-map-popup">${content}</div>` })

        const marker = new google.maps.Marker({
          position: { lat: parseFloat(leagueTarget.dataset.lat), lng: parseFloat(leagueTarget.dataset.lng) },
          map: this.map,
          title: leagueTarget.dataset.name,
          icon: this.data.get("mapMarkerIconUrl")
        })
        this.markers.push(marker)

        marker.addListener("click", () => {
          if (this.openInfoWindow) {
            this.openInfoWindow.close()
          }

          this.openInfoWindow = infoWindow
          this.openInfoWindow.open(this.map, marker)
        })
      }
    }
  }
}
